import "../SMSSolutions/SMSSolutions.css";
import {
  FaCheckCircle,
  FaBolt,
  FaChartLine,
  FaLightbulb,
  FaShieldAlt,
  FaUserTie,
  FaUniversity,
  FaBuilding,
} from "react-icons/fa";
import centerImage from "../../pages/IVRSolutions/assets/ss.png";
import flowStockbrokerImage from "./assets/flow-stockbrocker.png";
const StockbrokerSoftware = () => {
  return (
    <>
      <div className="services-bannerff">
        <div className="overlayff"></div>
        <div className="contentff">
          <div className="lineff"></div>
          <div>
            <h1>Dropcopy & FTP Solutions</h1>
            <p>
              <b className="bold">Dropcopy</b> and <b className="bold">FTP</b>
              are built for broker operations that need speed, visibility, and
              compliance. <br /> Dropcopy delivers real-time trade monitoring
              and streaming updates, while FTP ensures reliable file access,
              download, and management from one web-based interface.
            </p>
            <p>
              <span className="homeff">Home</span> → Service → Stockbroker
              Software
            </p>
          </div>
        </div>
      </div>
      <section className="ivr-section">
        <div className="ivr-container">
          <section className="about-sectionvv">
            <div className="about-containervv">
              <div className="about-contentvv">
                <span className="about-tagvv">Dropcopy</span>

                <h1>Dropcopy - Key Benefits</h1>

                <p className="about-descvv">
                  Dropcopy gives brokerage firms a real-time operating view of
                  exchange trade activity. It is useful for high-volume trading
                  environments where teams need instant monitoring, reliable
                  position visibility, and structured search across users,
                  clients, and CTCL levels.
                </p>
                <div className="about-featuresvv">
                  <div className="feature-rightvv">
                    <p>
                      <FaCheckCircle /> Web based access
                    </p>
                    <p>
                      <FaCheckCircle /> Real-time data from NSE on lease line
                    </p>
                    <p>
                      <FaCheckCircle /> Useful for firms having high trade volume
                    </p>
                    <p>
                      <FaCheckCircle /> Real-time consolidated net position
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <section className="services-bb">
              <div className="container-bb">
                <h5 className="subheading-bb">Dropcopy Flow</h5>
                <h2 className="heading-bb">Dropcopy Process Flow</h2>

                <div style={{ marginTop: "24px" }}>
                  <img
                    src={flowStockbrokerImage}
                    alt="Dropcopy flow diagram"
                    style={{ width: "100%", maxWidth: "1100px", height: "auto", display: "block", margin: "0 auto" }}
                  />
                </div>
              </div>
            </section>
            <section className="why-section">
              <div className="why-left">
                <span className="tags">Dropcopy</span>

                <h1>More Dropcopy Benefits</h1>
                <p>
                  Dropcopy is designed for brokerage operations that require
                  real-time analysis, fast traceability, RMS and BackOffice
                  integration, and communication support for compliance.
                </p>
                <br />
              </div>

              <div className="why-container">
                <div className="why-right">
                  <div className="card">
                    <p>
                      <FaBolt className="why-icon" /> CTCL Wise Summary :-
                      Get CTCL-level visibility for controlled operational
                      monitoring.
                    </p>
                  </div>
                  <div className="card">
                    <p>
                      <FaChartLine className="why-icon" /> Search Trade by
                      Instrument / Symbol / User Id / Client Id / CTCL Id :-
                      Find required trade records quickly.
                    </p>
                  </div>
                  <div className="card">
                    <p>
                      <FaLightbulb className="why-icon" /> Trade Data Streaming
                      for Real-time updates in RMS / BackOffice :-
                      Keep internal systems continuously updated.
                    </p>
                  </div>
                  <div className="card">
                    <p>
                      <FaShieldAlt className="why-icon" /> Integrated SMS
                      Platform :- Improve communication with real-time trade and
                      confirmation updates.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="why-sectionz">
              <h2>FTP - Advantages</h2>

              <p className="why-descz">
                FTP helps operations teams manage files faster with web access,
                segment-level visibility, and long-term local storage control.
              </p>

              <div className="why-containerz">
                <div className="why-gridz">
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle />
                      Web based access
                    </p>
                    <p>
                      <FaCheckCircle />
                      Download folder and multiple files on single click
                    </p>
                    <p>
                      <FaCheckCircle /> Access multiple segments on same page
                    </p>
                    <p>
                      <FaCheckCircle /> Auto download files
                    </p>
                  </div>
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle /> Keep files locally as long as you want
                    </p>
                    <p>
                      <FaCheckCircle /> Search files easily
                    </p>
                    <p>
                      <FaCheckCircle /> Add multiple users
                    </p>
                    <p>
                      <FaCheckCircle /> Create your bookmark list
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="industriesss">
              <h2>SMS and Compliance</h2>
              <p>
                Compliance and communication features included in Dropcopy:
              </p>
              <br />
              <div className="industries-containerss">
                <div className="industries-rightss">
                  <div className="cardss"><FaUserTie className="industry-icon" /> Integrated SMS platform</div>
                  <div className="cardss"><FaUniversity className="industry-icon" /> Client management for SMS</div>
                  <div className="cardss"><FaChartLine className="industry-icon" /> SMS confirmation report for compliance</div>
                  <div className="cardss"><FaBuilding className="industry-icon" /> Audit-friendly communication trail</div>
                </div>
              </div>
            </section>

            <section className="whyss">
              <p className="subtitless">WHY CHOOSE US</p>
              <h2 className="titless">
                Why Choose Our Dropcopy and FTP Suite
              </h2>
              <p>
                Built for brokerage firms that need operational speed,
                traceability, and compliance from a single web-based workflow.
              </p>
              <br />
              <div className="why-containerss">
                <div className="center-imagess">
                  <img src={centerImage} alt="transport" />
                </div>
                <div className="left-cardsss">
                  <div className="cardsss left-card card1">
                    <span>Real-time NSE Dropcopy Visibility</span>
                  </div>
                  <div className="cardsss left-card card2">
                    <span>High Volume Trade Monitoring</span>
                  </div>
                </div>
                <div className="right-cards">
                  <div className="cardsss left-card card3">
                    <span>RMS and BackOffice Data Streaming</span>
                  </div>
                  <div className="cardsss right-card card4">
                    <span>Flexible Multi-user FTP Access</span>
                  </div>
                  <div className="cardsss right-card card4">
                    <span>SMS Confirmation for Compliance</span>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default StockbrokerSoftware;
